/* eslint-disable  */
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { productActionCreators } from "../../services/Actions";
import { GetUserProfile } from "../../services/Actions/authActions";
import RenderHirePurchasePage from "../RenderHirePurchasePage";
import Loader from "../../Components/Loader";
import { debounce } from "lodash";
import { ToastContainer, toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import {
  FiSearch,
  FiList,
  FiEye,
  FiActivity,
  FiUser,
  FiCalendar,
  FiMapPin,
} from "react-icons/fi";

function OrderStatus() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { GetAllOrders, ResetProductResponse } = bindActionCreators(
    productActionCreators,
    dispatch
  );

  const product = useSelector((state) => state.product);
  const { isLoading, orders, response, paginate } = product;

  const [limit, setLimit] = useState(15);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    setPageCount(Number(paginate?.total) || 0);
  }, [paginate]);

  useEffect(() => {
    dispatch(GetUserProfile());
    GetAllOrders(true, 1, limit, null);
  }, []);

  const handleLimitChange = (e) => {
    const newLimit = e.target.value;
    setLimit(newLimit);
    GetAllOrders(true, 1, newLimit, null);
  };

  const onSearchTextChange = debounce((e) => {
    const val = e?.target?.value;
    GetAllOrders(true, 1, limit, val ? `&search=${val}` : null);
  }, 800);

  const handlePageClick = (event) => {
    GetAllOrders(true, event.selected + 1, limit, null);
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => ResetProductResponse(), 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetProductResponse(), 1500);
    }
  }, [response?.state]);

  // Helper for Status Badge Styling
  const getStatusStyles = (status) => {
    switch (status?.toLowerCase()) {
      case "submitted":
        return "bg-gray-100 text-gray-700 border-gray-200";
      case "initiated":
        return "bg-orange-100 text-orange-700 border-orange-200";
      case "approved":
        return "bg-green-100 text-green-700 border-green-200";
      case "shipped":
        return "bg-blue-100 text-blue-700 border-blue-200";
      case "rejected":
        return "bg-red-100 text-red-700 border-red-200";
      default:
        return "bg-gray-100 text-gray-600 border-gray-200";
    }
  };

  return (
    <div className="min-h-screen bg-gray-50/30">
      <RenderHirePurchasePage>
        {isLoading && <Loader />}

        {/* --- Header Section --- */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-indigo-100 rounded-lg text-indigo-600">
              <FiActivity size={24} />
            </div>
            <h2 className="text-2xl font-bold text-gray-800">Order Status</h2>
          </div>
          <p className="text-sm text-gray-500">
            Overview of all hire purchase applications across all lifecycle
            stages.
          </p>
        </div>

        {/* --- Toolbar --- */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mb-6">
          <div className="md:col-span-8 relative">
            <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="search"
              placeholder="Search by staff ID or name..."
              className="w-full pl-12 pr-4 py-3 bg-white border border-gray-200 rounded-xl shadow-sm focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
              onChange={onSearchTextChange}
            />
          </div>

          <div className="md:col-span-4 flex items-center justify-end gap-3 bg-white px-4 py-2 rounded-xl border border-gray-200 shadow-sm">
            <FiList className="text-gray-400" />
            <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">
              Show
            </span>
            <select
              className="text-sm font-semibold text-gray-700 outline-none bg-transparent cursor-pointer"
              onChange={handleLimitChange}
              value={limit}
            >
              {[5, 10, 50, 150, 500].map((num) => (
                <option key={num} value={num}>
                  {num} rows
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* --- Data Table --- */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-100">
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500 tracking-wider">
                    Member
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500 tracking-wider">
                    Affordability
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500 tracking-wider">
                    Requested On
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500 tracking-wider">
                    Facility
                  </th>
                  <th className="px-6 py-4 text-xs font-bold uppercase text-gray-500 tracking-wider">
                    Current Status
                  </th>
                  <th className="px-6 py-4 text-right"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {orders?.length > 0 ? (
                  orders.map((order, index) => (
                    <tr
                      key={index}
                      className="hover:bg-indigo-50/20 transition-colors group"
                    >
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <img
                            className="w-10 h-10 rounded-full border-2 border-white shadow-sm object-cover"
                            src={
                              order?.user_id?.profile_image ||
                              `https://ui-avatars.com/api/?name=${order?.user_id?.name}`
                            }
                            alt=""
                          />
                          <div>
                            <p className="text-sm font-bold text-gray-900">
                              {order?.user_id?.name}
                            </p>
                            <p className="text-xs font-medium text-indigo-500 italic">
                              ID: {order?.user_id?.staff_id}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-sm font-semibold text-gray-700">
                          {order?.affordability}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <FiCalendar className="text-gray-300" />
                          {moment(order?.created_at).format("MMM Do, YYYY")}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-2 text-sm text-gray-600">
                          <FiMapPin className="text-gray-300" />
                          {order?.facility}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span
                          className={`inline-flex items-center px-3 py-1 rounded-full text-[10px] font-bold uppercase border tracking-tighter ${getStatusStyles(
                            order?.status
                          )}`}
                        >
                          {order?.status}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button
                          onClick={() =>
                            history.push({
                              pathname: "/mart/order-detailed",
                              state: order,
                            })
                          }
                          className="p-2 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all"
                          title="View Details"
                        >
                          <FiEye size={18} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      className="px-6 py-20 text-center text-gray-400 italic"
                    >
                      No matching records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* --- Pagination --- */}
          {orders?.length > 0 && (
            <div className="px-6 py-6 bg-gray-50 flex justify-center border-t border-gray-100">
              <ReactPaginate
                breakLabel="..."
                nextLabel="Next"
                previousLabel="Prev"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                pageCount={Math.ceil(pageCount / limit)}
                containerClassName="flex items-center gap-1"
                pageLinkClassName="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-gray-200 text-sm font-semibold text-gray-600 hover:border-indigo-500 hover:text-indigo-600 transition-all"
                activeLinkClassName="!bg-indigo-600 !text-white !border-indigo-600 shadow-md"
                previousLinkClassName="px-3 py-2 rounded-lg bg-white border border-gray-200 text-sm font-medium mr-2"
                nextLinkClassName="px-3 py-2 rounded-lg bg-white border border-gray-200 text-sm font-medium ml-2"
                disabledLinkClassName="opacity-30 cursor-not-allowed"
              />
            </div>
          )}
        </div>
        <ToastContainer autoClose={3000} />
      </RenderHirePurchasePage>
    </div>
  );
}

export default OrderStatus;
